import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Form, Label, Modal, TextAreaProps } from "semantic-ui-react";

import ModalApp from "../../components/ModalApp";
import { INotificacao, Roles } from "../../interfaces";
import NotificationRepository from "../../Repositories/NotificationRepository";
import errors, { IAliancaErrors } from "../../Utils/ExtractErrors";
import { getDescriptionPending } from "../../Utils/GetNotificationDescription";

export interface INotificationPersons {
    personToNotify: IPerson;
    notificationPerson: IPersonNotification;
}

interface IPerson {
    id: string;
    role: Roles;
}

interface IPersonNotification extends IPerson {
    name: string;
}

interface IProps {
    personToNotify: IPerson;
    pendingPerson: IPersonNotification;
    disabled: boolean;
    onSavePerson: () => Promise<any>
    onSuccess: () => void;
}

interface IState extends Omit<INotificacao, "id" | "criadaEm" | "criadaPor" | "recebedores" | "pessoaPendente"> {
    apiErrors: IAliancaErrors;
    open: boolean;
    saving: boolean;
}

const initialState: IState = {
    apiErrors: { errors: [] },
    descricao: "",
    mensagem: "",
    open: false,
    saving: false
}

export default function CadastroMotivoPendente(props: IProps) {
    const [state, setState] = useState<IState>(initialState);

    useEffect(() => {
        const error = errors.getErrors({ errors: state.apiErrors.errors }, "ApiError");
        if (error !== undefined) {
            toast(error, { position: "top-center", type: "error" });
        }
    }, [state.apiErrors]);

    async function handleOnSuccess() {
        try {
            setState(state => ({ ...state, saving: true }));

            const response = await NotificationRepository.Create({
                descricao: getDescriptionPending(props.pendingPerson.role, props.pendingPerson.name),
                mensagem: state.mensagem,
                pessoaPendente: props.pendingPerson.id,
                recebedores: [
                    {
                        recebedorId: props.personToNotify.id,
                        userLevel: props.personToNotify.role
                    }
                ]
            });
            toast(response.message, { position: "top-center", type: "success" });
            setState(initialState);
            props.onSuccess();
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }
            setState(state => ({ ...state, apiErrors: err.response.data, saving: false }));
        }
    }

    function handleOnOpen() {
        setState(state => ({ ...state, open: true }));
        try {
            props.onSavePerson();
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }
            setState(state => ({ ...state, apiErrors: err.response.data }));
        }
    }

    function handleOnClose() {
        setState(initialState);
    }

    function onChangeTextArea(event: React.FormEvent<HTMLTextAreaElement>, data: TextAreaProps) {
        setState(state => ({ ...state, [data.name]: data.value }));
    }

    const hasError = (key: string) => {
        return errors.hasError(state.apiErrors, key);
    }

    const getMessage = (key: string) => {
        return errors.getMessage(state.apiErrors, key);
    }

    const content = (
        <Modal.Content>
            <Form>
                <Form.Field error={hasError("Mensagem")} required>
                    <label>Mensagem</label>
                    <Form.TextArea
                        placeholder="Mensagem"
                        name="mensagem"
                        value={state.mensagem}
                        onChange={onChangeTextArea}
                    />
                    {hasError("Mensagem") && <Label pointing prompt>{getMessage("Mensagem")}</Label>}
                </Form.Field>
            </Form>
        </Modal.Content>
    );

    return (
        <ModalApp
            open={state.open}
            title="Motivo pendente"
            content={content}
            trigger={{
                fluid: true,
                disabled: props.disabled,
                color: "orange",
                content: "Cadastrar/Alterar motivo de cadastro pendente",
            }}
            handleOpen={handleOnOpen}
            handleClose={handleOnClose}
            onSuccess={{
                content: "Salvar",
                func: handleOnSuccess,
                loading: state.saving
            }}
        />
    );
}
